import { render, staticRenderFns } from "./ErrorSubmitForm1.vue?vue&type=template&id=6e77bb5b&scoped=true"
import script from "./ErrorSubmitForm1.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77bb5b",
  null
  
)

export default component.exports